"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commonPropTypes = _interopRequireDefault(require("./controls/common-prop-types"));

var _componentCommon = require("./component-common");

var _errorMessages = _interopRequireDefault(require("./error-messages"));

var _help = _interopRequireDefault(require("./help"));

var _row = _interopRequireDefault(require("./row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CheckboxGroup = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxGroup, _Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var _this$props = _this.props,
          options = _this$props.options,
          name = _this$props.name,
          onSetValue = _this$props.onSetValue,
          onChange = _this$props.onChange;
      var checkedOptions = options.filter(function (option) {
        return _this.elements[option.value].checked;
      });
      var value = checkedOptions.map(function (option) {
        return option.value;
      });
      onSetValue(value);
      onChange(name, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderElement", function () {
      var _this$props2 = _this.props,
          options = _this$props2.options,
          value = _this$props2.value,
          disabled = _this$props2.disabled;
      var controls = options.map(function (checkbox) {
        var checked = value.indexOf(checkbox.value) !== -1;
        var isDisabled = checkbox.disabled || disabled;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "checkbox",
          key: checkbox.value
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
          ref: function ref(input) {
            _this.elements[checkbox.value] = input;
          },
          checked: checked,
          type: "checkbox",
          value: checkbox.value,
          onChange: _this.handleChange,
          disabled: isDisabled
        }), ' ', checkbox.label));
      });
      return controls;
    });

    _this.elements = {};
    return _this;
  } // Returns an array of the values of all checked items.


  _createClass(CheckboxGroup, [{
    key: "render",
    value: function render() {
      var element = this.renderElement();
      var _this$props3 = this.props,
          layout = _this$props3.layout,
          help = _this$props3.help,
          showErrors = _this$props3.showErrors,
          errorMessages = _this$props3.errorMessages;

      if (layout === 'elementOnly') {
        return /*#__PURE__*/_react["default"].createElement("div", null, element);
      }

      return /*#__PURE__*/_react["default"].createElement(_row["default"], _extends({}, this.props, {
        fakeLabel: true
      }), element, help ? /*#__PURE__*/_react["default"].createElement(_help["default"], {
        help: help
      }) : null, showErrors ? /*#__PURE__*/_react["default"].createElement(_errorMessages["default"], {
        messages: errorMessages
      }) : null);
    }
  }]);

  return CheckboxGroup;
}(_react.Component);

CheckboxGroup.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _commonPropTypes["default"]), _componentCommon.componentPropTypes), {}, {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    disabled: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    label: _propTypes["default"].string,
    key: _propTypes["default"].string
  })),
  value: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
CheckboxGroup.defaultProps = _objectSpread(_objectSpread({}, _componentCommon.componentDefaultProps), {}, {
  options: [],
  value: []
});
var _default = CheckboxGroup;
exports["default"] = _default;